import axios from 'axios';
import { refreshToken, checkHttpStatus } from '../../common/utils/ApiUtils';
import { NEW_USER, VERIFY_USER, PROCESS_CONFIRM, AUTHENTICATE_USER, DEAUTHENTICATE_USER } from './index';

const PARCHMENT_IDENTITY_SERVICE_BASE_URL = window.config.service.parchmentIdentityProviderUrl;

refreshToken('parchment-identity-provider');

export function addNewUser(params) {
    const url = `${PARCHMENT_IDENTITY_SERVICE_BASE_URL}/individual`;
    const response = axios.post(url, params);

    return {
        type: NEW_USER,
        payload: response.then(checkHttpStatus)
    }
}

export function verifyUser(params) {
    const response = axios.post('/u/registration/institution/verify', params);

    return {
        type: VERIFY_USER,
        payload: response.then(checkHttpStatus)
    }
}

export function processConfirmation(params) {
    const response = axios.post('/u/registration/institution/process/confirm', params);

    return {
        type: PROCESS_CONFIRM,
        payload: response.then(checkHttpStatus)
    };
}

export function authenticateNewUser(username, password, senderId) {
    const params = new FormData();
    params.append('csrfToken', window.config.csrfToken);
    params.append('username', username);
    params.append('password', password);
    if(typeof senderId !== 'undefined') {
        params.append('tpoSenderId', senderId);
    }
    const response = axios.post('/u/api/login', params,
        {headers: {'X-Requested-With': 'XMLHttpRequest'}});

    return {
        type: AUTHENTICATE_USER,
        payload: response
    };
}

export function logoutNewUser() {
    const response = axios.get('/u/auth/logout',
        {headers: {'X-Requested-With': 'XMLHttpRequest'}});

    return {
        type: DEAUTHENTICATE_USER,
        payload: response
    };
}
